export enum WhoOptionsSurgery {
    General = 1,
    Cardiac_Thoracic = 2,
    Neurosurgery = 3,
    Orthopedic_Surgery = 4,
    Obstetric_And_Gynecological_Surgery = 5,
    Ophthalmic_Surgery = 6,
    Laparoscopic_Surgery = 7,
    Transplant_Surgery = 8,
    Plastic_And_Reconstructive = 9,
    Maxilla_Facial = 10,
    ENT = 11,
    Urology = 12,
    Gastro_Enterology = 13
}


